import { clone } from '../object/clone';

/**
 * Metodo que permite ejecutar una(s) función(es) `callback` para cada property del view.
 * Recorre el view recursivamente.
 * Devuelve una copia
 *
 * @example mapper(view, (property, parent) => {...})
 *
 * _typedef {{ properties: MapperViewField[]|undefined }} MapperViewField
 * @typedef {Object} MapperViewField View o ViewField, solo miramos el properties opcional
 * @property {MapperViewField[]} [properties]
 *
 * @param {MapperViewField} view el view completo
 * @param {Function[]} callbacks el metodo que se lanzara para cada property, ej. `callback(propezrty, parentProperty)`
 */
export function mapper(view, ...callbacks) {
  const cloned = clone(view);
  callbacks = callbacks.filter(callback => typeof callback === 'function');
  return callbacks?.length ? flatmapRecursive(cloned) : cloned;

  /**
   *
   * @param {MapperViewField} property
   * @param {MapperViewField} [parent]
   * @returns {MapperViewField}
   */
  function flatmapRecursive(property, parent) {
    callbacks.forEach(callback => {
      property = callback(property ?? {}, parent);
    });

    if (Array.isArray(property?.properties)) {
      property.properties = property.properties.map(child => {
        return flatmapRecursive(child, property);
      });
    }

    return property;
  }
}
